import type { RealisasiResultType } from 'types/kinerja'

export const PENGEMBANGAN_KOMPETENSI_REALISASI_RESULT: Record<
  RealisasiResultType,
  { label: string; className: string }
> = {
  BELOW_EXPECTATION: {
    label: 'Belum memenuhi ekspektasi',
    className: 'bg-orange-10',
  },
  MEET_EXPECTATION: {
    label: 'Sudah memenuhi ekspektasi',
    className: 'bg-green-5',
  },
  EXCEED_EXPECTATION: {
    label: 'Melebihi ekspektasi',
    className: 'bg-cyan-5',
  },
}
